import { Typography } from "@mui/material";
import { NotificationType } from "generated/CoreApi_v1";
import React, { ReactNode } from "react";
import { Link } from "react-router";
import { FoundationPaths } from "routes/FoundationRouter";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { LmsPaths } from "routes/LmsRouter";
import { MessengerResolver } from "views/foundation/notification/resolvers/MessengerResolver";

////////////////////////////////////////////////////////////////////////////////

export class FoundationResolver extends MessengerResolver {

    static messengerId: string[] = [
        "Foundation.*",
    ];

    protected translateAction(): ReactNode {
        if (this.notification.notificationTypeId == NotificationType.FoundationReminderAnswerChallenge)
            return this.knowledgeTests();

        if (this.notificationActionKeys == null)
            return this.notificationAction?.title ?? "?";

        switch (this.notification.notificationTypeId) {
            case NotificationType.FoundationTopicEndorsement:
            case NotificationType.FoundationTopicGrantSealProvenKnowledge:
            case NotificationType.FoundationTopicKeepSealProvenKnowledge:
            case NotificationType.FoundationTopicLostSealProvenKnowledge:
            case NotificationType.FoundationTopicSpecialistByManager:
                return this.topicLink();

            case NotificationType.FoundationImportUsers:
            case NotificationType.FoundationImportUnits:
                return <Link to={FoundationPaths.BuildLoadData(this.notificationAction!.keys![1])} title={this.notificationAction!.keys![0]} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.keys![0]}</Typography>
                </Link>;

            case NotificationType.FoundationSpyLogin:
                return this.userProfile();
        }

        return "???";
    }

    protected topicLink(): React.ReactNode {
        return <Link to={`${KnowledgePaths.FeedTopic(this.notificationAction!.keys![0])}`} title={this.notificationAction!.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
        </Link>;
    }

    protected knowledgeTests(): React.ReactNode {
        return <Link to={LmsPaths.NewKnowledgeTest} title={this.notificationAction!.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
        </Link>;
    }

    protected userProfile(): React.ReactNode {
        return <Link to={KnowledgePaths.FeedUserProfile(this.notificationAction!.keys![0])} title={this.notificationAction!.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
        </Link>;
    }
}
